export const DEFAULT_API_VERSION = 'v23.0';
export const BASE_URL = 'https://graph.facebook.com';
export const DEFAULT_TIMEOUT = 30000; // 30 seconds
export const MAX_RETRY_ATTEMPTS = 3;
export const RETRY_DELAY_MS = 1000;

export const API_ENDPOINTS = {
  MESSAGES: '/me/messages',
  MESSAGE_ATTACHMENTS: '/me/message_attachments',
  MODERATE_CONVERSATIONS: '/me/moderate_conversations',
  USER_PROFILE: '', // Dynamic endpoint: /{PSID}
} as const;

// Validation constants
export const MESSAGE_LIMITS = {
  // Text messages
  TEXT_MESSAGE_MAX_CHARS: 2000,
} as const;

export const ATTACHMENT_LIMITS = {
  // File size limits in bytes
  IMAGE_MAX_SIZE: 8 * 1024 * 1024, // 8MB
  OTHER_MAX_SIZE: 25 * 1024 * 1024, // 25MB (video, audio, file)
  
  // Timeout limits in seconds
  VIDEO_TIMEOUT: 75,
  OTHER_TIMEOUT: 10,
} as const;

export const TEMPLATE_LIMITS = {
  // Generic Template
  GENERIC_ELEMENTS_MAX: 10,
  GENERIC_TITLE_MAX_CHARS: 80,
  GENERIC_SUBTITLE_MAX_CHARS: 80,
  
  // Button Template  
  BUTTON_TEXT_MAX_CHARS: 640,
  BUTTONS_MAX_COUNT: 3,
  BUTTON_TITLE_MAX_CHARS: 20,
  
  // All Templates
  POSTBACK_PAYLOAD_MAX_CHARS: 1000,
  
  // Media Template
  MEDIA_ELEMENTS_COUNT: 1, // Exactly 1 element required
  MEDIA_BUTTONS_MAX_COUNT: 3,
} as const;